import { render, staticRenderFns } from "./MainContactEditor.vue?vue&type=template&id=fa608a1c&scoped=true&"
import script from "./MainContactEditor.vue?vue&type=script&lang=js&"
export * from "./MainContactEditor.vue?vue&type=script&lang=js&"
import style0 from "./MainContactEditor.vue?vue&type=style&index=0&id=fa608a1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa608a1c",
  null
  
)

export default component.exports